import { useState, useEffect } from "react";
import "./style.css";

import logo from "../../assets/image/update/logo.png";
import iosIconEn from "../../assets/image/update/iosIconEn.png";
import aosIconEn from "../../assets/image/update/aosIconEn.png";
import iosIconTc from "../../assets/image/update/iosIconTc.png";
import aosIconTc from "../../assets/image/update/aosIconTc.png";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
// import { redirectToAppStore } from "../../util/common";

const Update = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();

  const iosClick = () => {
    window.location.href =
      "https://apps.apple.com/hk/app/caf%C3%A9-de-coral/id1436965382";
  };
  const aosClick = () => {
    window.location.href =
      "https://play.google.com/store/apps/details?id=com.cdc.cdcmember";
  };

  // useEffect(() => {
  //   redirectToAppStore();
  // }, []);

  useEffect(() => {
    if (lang === "en") {
      i18n.changeLanguage("en");
    } else {
      i18n.changeLanguage("zh");
    }
  }, [lang, i18n]);

  return (
    <div lang={lang} className="update-contianer">
      <div lang={lang} className="update-body">
        <div className="update-body-header">
          <img src={logo} alt="logo" className="update-logo" />
        </div>
        <div className="update-body-content">
          <div lang={lang} className="update-title">
            {t("update_title_1")}
            <br />
            {t("update_title_2")}
          </div>
          <div lang={lang} className="update-desc">
            {t("update_desc")}
          </div>
          <div className="update-icon">
            <img
              src={lang === "en" ? iosIconEn : iosIconTc}
              alt="iosIcon"
              className="ios-icon"
              onClick={iosClick}
            />
            <img
              src={lang === "en" ? aosIconEn : aosIconTc}
              alt="aosIcon"
              className="aos-icon"
              onClick={aosClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Update;
